import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=7c2c743c"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports